import { type ReactNode } from "react";
import styles from "./Toolbar.module.css";

export interface ToolbarProps {
  leading?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  /** Right-aligned search affordance (hidden on narrow screens). */
  search?: ReactNode;
  trailing?: ReactNode;
  large?: boolean;
  className?: string;
  children?: ReactNode;
}

export function Toolbar({
  leading,
  title,
  subtitle,
  search,
  trailing,
  large = false,
  className,
  children,
}: ToolbarProps) {
  return (
    <header className={[styles.toolbar, large ? styles.large : "", className ?? ""].join(" ")}>
      {large ? (
        <>
          <div className={styles.headerRow}>
            <div className={styles.titleWrap}>
              {leading}
              {title && <h1 className={styles.largeTitle}>{title}</h1>}
              {subtitle && <span className={styles.largeSubtitle}>{subtitle}</span>}
            </div>
            {(search || trailing) && (
              <div className={styles.actions}>
                {search && <div className={styles.searchSlot}>{search}</div>}
                {trailing}
              </div>
            )}
          </div>
          {children}
        </>
      ) : (
        <div className={styles.bar}>
          <div className={styles.leading}>{leading}</div>
          {title && <h1 className={styles.title}>{title}</h1>}
          <div className={styles.trailing}>{trailing}</div>
        </div>
      )}
    </header>
  );
}
